import { IconType } from "react-icons";
import { UserModuleNameTypes } from "./models/userAccess/UserAccess.model";
import { TbBook, TbBriefcase, TbMessageHeart } from "react-icons/tb";
import { BiSolidBookAdd } from "react-icons/bi";

type NavItemTypeWithoutChild = {
  label: string;
  moduleName: string;
  path: string;
  icon: IconType;
  children?: never;
};

type NavItemTypeWithChild = {
  label: string;
  moduleName: string;
  path?: never;
  icon: IconType;
  children?: {
    label: string;
    moduleName: string;
    path: string;
    icon: IconType;
  }[];
};

export type NavItemType = NavItemTypeWithChild | NavItemTypeWithoutChild;

export const websiteNavigation: NavItemType[] = [
  {
    label: "Job Board",
    moduleName: UserModuleNameTypes.QUESTION,
    icon: TbBriefcase,
    path: "jobs",
  },
  {
    label: "Student Testimonials",
    moduleName: UserModuleNameTypes.TESTIMONIALS,
    icon: TbMessageHeart,
    path: "student-testimonials",
  },
  {
    label: "Blogs",
    moduleName: UserModuleNameTypes.BLOGS,
    icon: TbBook,
    path: "blogs",
  },
  {
    label: "Web Course",
    moduleName: UserModuleNameTypes.BLOGS,
    icon: BiSolidBookAdd,
    path: "web-course",
  },
];
